import { instanceWithAuth } from './index'

// 로그인 유지 수정 (변경된 토큰값이 들어간 userInfo를 통으로 리턴받음)
function updateToken(userInfo) {
  return instanceWithAuth.patch('mobile/updatetoken', userInfo)
}

// 푸시 수신 설정 변경
function updatePushYn(pushData) {
  return instanceWithAuth.patch('mobile/mypage/updatepush', pushData)
}

// 마이페이지의 배지
function getBadge() {
  return instanceWithAuth.get('mobile/mypage/badge')
}

// 마이페이지의 배지함 (기간지정)
function getBadgeBox(searchYear) {
  return instanceWithAuth.get('mobile/mypage/badgebox', {
    params: {
      // startDt: search.startDt,
      // endDt: search.endDt,
      searchYear: searchYear,
    },
  })
}

export { updateToken, updatePushYn, getBadge, getBadgeBox }
